import { ApiDimension } from "@incendium/api";
import { IChart } from "Interfaces";
import { useMemo } from "react";

const trendDimensions = [
  ApiDimension.DIMENSION_SESSION_START_BY_HOUR,
  ApiDimension.DIMENSION_SESSION_START_BY_DAY,
  ApiDimension.DIMENSION_SESSION_START_BY_WEEK,
  ApiDimension.DIMENSION_SESSION_START_BY_MONTH,
  ApiDimension.DIMENSION_SESSION_START_DATE,
  ApiDimension.DIMENSION_FIRST_SALE_DATE,
  ApiDimension.DIMENSION_FIRST_SALE_MONTH,
];

// Import the function directly to avoid circular dependency
const filterTrendDimensions = (dimensions: ApiDimension[]) =>
  (dimensions || []).filter((d) => {
    return trendDimensions.includes(d);
  });

const filterNonTrendDimensions = (dimensions: ApiDimension[]) =>
  (dimensions || []).filter((d) => {
    return !trendDimensions.includes(d);
  });

const useTrendDimensions = (chart: IChart) => {
  return {
    trendDimensions: useMemo(
      () => filterTrendDimensions(chart.dimension as ApiDimension[]),
      [chart.dimension]
    ),
    nonTrendDimensions: useMemo(
      () => filterNonTrendDimensions(chart.dimension as ApiDimension[]),
      [chart.dimension]
    ),
  };
};

export default useTrendDimensions;
